var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "menu-sheet" }, [
    _c("div", {
      staticClass: "menu-sheet__backdrop",
      on: { click: _vm.requestClose },
    }),
    _c("div", { staticClass: "menu-sheet__column" }, [
      _c(
        "aside",
        {
          ref: "panel",
          staticClass: "menu-sheet__panel",
          class: { "is-dragging": _vm.dragging },
          style: _vm.panelStyle,
          attrs: {
            role: "dialog",
            "aria-label": _vm.$t("assistantCatHome.openMenu"),
          },
          on: {
            pointerdown: _vm.onPointerDown,
            pointermove: _vm.onPointerMove,
            pointerup: _vm.onPointerUp,
            pointercancel: _vm.onPointerUp,
          },
        },
        [
          _c("button", {
            staticClass: "menu-sheet__handle",
            attrs: {
              type: "button",
              "aria-label": _vm.$t("assistantCatHome.closeMenu"),
            },
            on: { click: _vm.onHandleClick },
          }),
          _c(
            "div",
            { ref: "body", staticClass: "menu-sheet__body" },
            [
              _c("div", { staticClass: "menu-sheet__fish" }, [
                _c("div", { staticClass: "menu-sheet__fish-row" }, [
                  _c("div", { staticClass: "menu-sheet__balance" }, [
                    _c("img", {
                      attrs: {
                        src: require("@/assets/img/icon/fish_icon.png"),
                        alt: _vm.$t("purchaseFish.product.fishIcon"),
                      },
                    }),
                    _c("span", [_vm._v(_vm._s(_vm.fishLabel))]),
                  ]),
                  _c(
                    "button",
                    {
                      staticClass: "menu-sheet__charge",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          return _vm.$emit("charge")
                        },
                      },
                    },
                    [
                      _c("icon-add"),
                      _c("span", [
                        _vm._v(_vm._s(_vm.$t("assistantCatHome.menu.charge"))),
                      ]),
                    ],
                    1
                  ),
                ]),
                _c("div", { staticClass: "menu-sheet__fish-meta" }, [
                  _c(
                    "button",
                    {
                      staticClass: "menu-sheet__breakdown",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          return _vm.$emit("charge-breakdown")
                        },
                      },
                    },
                    [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.$t("assistantCatHome.menu.chargeBreakdown")
                          )
                        ),
                      ]),
                      _c("span", { staticClass: "menu-sheet__meta-amount" }, [
                        _vm._v(_vm._s(_vm.chargeLabel)),
                      ]),
                      _c("icon-chevron-right", {
                        staticClass: "menu-sheet__breakdown-chevron",
                      }),
                    ],
                    1
                  ),
                  _c("span", { staticClass: "menu-sheet__bonus" }, [
                    _c("span", [
                      _vm._v(_vm._s(_vm.$t("assistantCatHome.menu.bonus"))),
                    ]),
                    _c("span", { staticClass: "menu-sheet__meta-amount" }, [
                      _vm._v(_vm._s(_vm.bonusLabel)),
                    ]),
                  ]),
                ]),
              ]),
              _c("assistant-cat-home-menu-panel", {
                attrs: {
                  variant: "sheet",
                  "writer-type": _vm.writerType,
                  "feedback-manuscript-mode": _vm.feedbackManuscriptMode,
                  "generate-summary-mode": _vm.generateSummaryMode,
                },
                on: {
                  action: function ($event) {
                    return _vm.$emit("action", $event)
                  },
                },
              }),
            ],
            1
          ),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }